import { Link } from "@/components/site/LocaleLink";
import { ChevronRight } from "lucide-react";
import { motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import { Picture } from "@/components/site/Picture";

export const PageHero = ({ title, subtitle, image, crumb }) => {
  const { t } = useLang();
  return (
    <section className="relative overflow-hidden bg-forest pt-[74px] text-cream" data-testid="page-hero">
      {image && (
        <>
          <Picture
            img={image}
            alt=""
            className="absolute inset-0 h-full w-full object-cover opacity-25"
            sizes="100vw"
            priority
          />
          <div className="absolute inset-0 bg-gradient-to-t from-forest-deep via-forest/80 to-forest/50" />
        </>
      )}
      <div className="noise pointer-events-none absolute inset-0 opacity-[0.05]" />
      <div className="container-x relative py-20 lg:py-28">
        <motion.nav
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6 }}
          className="mb-6 flex items-center gap-2 text-xs text-cream/60"
        >
          <Link to="/" className="transition-colors hover:text-gold-light">
            {t.nav.home}
          </Link>
          <ChevronRight className="h-3.5 w-3.5 rtl-flip" />
          <span className="text-gold-light">{crumb || title}</span>
        </motion.nav>
        <motion.h1
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-4xl font-display text-4xl font-extrabold leading-tight tracking-tight sm:text-5xl lg:text-6xl"
        >
          {title}
        </motion.h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.15, duration: 0.8 }}
            className="mt-6 max-w-2xl text-base leading-relaxed text-cream/80 sm:text-lg"
          >
            {subtitle}
          </motion.p>
        )}
      </div>
    </section>
  );
};
